<template>
  <v-app>
    <v-app-bar 
      app 
      clipped-left
      color="green"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"><v-icon large>mdi-cart-plus</v-icon></v-app-bar-nav-icon>
      <v-toolbar-title>ProCart</v-toolbar-title>
      <p style="margin-bottom: 0px; font-size: 0.9em; margin-left: 1em;">app: {{info.version}}</p>
      <v-spacer></v-spacer>
      <div class="mr-4" style="font-size: 0.75em;" >
        <div>Информация о лицензии:</div>
        <div>Статус: <span :style="get_license_style(info.lic_date)">{{info.status}}</span></div>
        <div >Срок действия: <span :style="get_license_style(info.lic_date)">{{info.lic_date}}</span></div>
      </div>
      <v-btn
          class="ml-4"
          icon
          :loading="loading"
          :disabled="loading"
          @click="update_license"
          title="Обновить информацию о лицензии"
          >
          <v-icon style="color: rgba(255,255,255, .5)">mdi-update</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
    >
      <v-list>
        <v-list-item
          to="/"
          link
          exact
          color="green"
        >
          <v-list-item-icon>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Настройки</v-list-item-title>
        </v-list-item>

        <v-list-item
          href="/docs"
          link
          exact
          color="green"
        >
          <v-list-item-icon>
            <v-icon>mdi-api</v-icon>
          </v-list-item-icon>
          <v-list-item-title>ProCart API</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>


<script>

export default {
	data: () => ({
    drawer: true,
    info: {
      lic_date: 'null',
      status: 'null',
      version: 'null'
    },
    loading: false,
	}),
  methods: {
    async update_license(){
      this.loading = true
      await this.$store.dispatch('getInfo')
      this.info = this.$store.getters.info
      await new Promise(resolve => setTimeout(resolve, 1000));
      this.loading = false
    },
    get_license_style(dt_arg) {
      let day = dt_arg.slice(0, 2)
      let month = dt_arg.slice(3, 5)
      let year = dt_arg.slice(6, 10)
      dt_arg = new Date(year + '-' + month + '-' + day)
      
      let dt_now = new Date()
      let subs = dt_arg - dt_now

      if (subs < 0) subs = 0

      if (subs < 86400000) { //one day
        return 'background-color: #c0392b; color: #ecf0f1;'
      } else if (subs < 259200000) { // three days
        return 'background-color: #f39c12; color: #2c3e50;'
      } else {
        return ''
      }
    }
  },

  async mounted(){
    await this.$store.dispatch('getInfo')
    this.info = this.$store.getters.info
  }
};
</script>